// extracted by mini-css-extract-plugin
export default {"contactIcons":"SmsLogs_contactIcons__lL+NB","messageDisabled":"SmsLogs_messageDisabled__1lGmT","unreadCircle":"SmsLogs_unreadCircle__rE+VK"};